import { createAsyncThunk } from '@reduxjs/toolkit'
import { getData, getDataWithParams } from 'src/consumer/services/profileService'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'

export const getScreeningReportTemplateData = createAsyncThunk(
  'screeningReportData/getTemplateData',
  async ({ clinicBrandId }, { rejectWithValue, getState }) => {
    getScreeningReportTemplateData.pending()
    const { screeningReportTemplateStore } = getState()
    const screeningReportData = screeningReportTemplateStore?.screeningReportTemplate?.data
    if (!!screeningReportData && screeningReportData?.clinicBrandId === clinicBrandId) {
      return screeningReportData
    }

    const resp = await getDataWithParams('/api/secure/doctor/screening-report-template/get', {
      'clinic-brand-id': clinicBrandId,
    })

    if (resp?.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)?.screeningReportTemplate
        return { ...data, clinicBrandId: clinicBrandId }
      } else {
        return rejectWithValue(resp?.data?.message || 'Failed to fetch screening template data')
      }
    } else {
      return rejectWithValue(resp?.message || 'Failed to fetch screening template data')
    }
  },
)
